
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"124","height":"124"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"124","height":"124","fill":"#400F3F","rx":"16"}}),_c('path',{attrs:{"fill":"#FF4702","d":"M41.333 82.667a5.167 5.167 0 005.167 5.166h31a5.167 5.167 0 005.167-5.166V41.333a5.167 5.167 0 00-5.167-5.166H58.977a5.165 5.165 0 00-3.668 1.524L42.858 50.142a5.168 5.168 0 00-1.525 3.669v28.856zm23.25-6.459c0 .714-.578 1.292-1.291 1.292H50.375a1.292 1.292 0 01-1.292-1.292v-2.583c0-.713.579-1.292 1.292-1.292h12.917c.713 0 1.291.579 1.291 1.292v2.583zm10.334-10.333c0 .713-.579 1.292-1.292 1.292h-23.25a1.293 1.293 0 01-1.292-1.292v-2.583c0-.714.579-1.292 1.292-1.292h23.25c.713 0 1.292.578 1.292 1.292v2.583zM46.035 54.25l13.382-13.382v10.799a2.584 2.584 0 01-2.584 2.583H46.035z"}})])])
          )
        }
      }
    